import { useQuery } from '@tanstack/react-query'
import { getData } from '../../../apis/api.helpers'
import apiUrl from '../../../apis/api.url'
import { parseQueryParams } from '../../../utilities/parsers'

const buildUrlWithParams = (baseUrl: string) => {
  return `${baseUrl}${parseQueryParams()}`
}
const fetchSchemes = async () => {
  const url = buildUrlWithParams(apiUrl.SCHEMES_LIST)
  const response = await getData(url)
  return response
}
export const useFetchSchemes = () => {
  return useQuery(['members_listing'], () => fetchSchemes(), {
    refetchOnWindowFocus: false,
  })
}
